import { useMutation, useQueryClient } from '@tanstack/react-query';
import { addProviderActivationEvent, ProviderActivationEventName } from '@uplift/api';

import { providerQueryKeys } from './providerQueryKeys';

export const useAddProviderActivationEventMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [ 'provider', 'activation', 'events' ],
    mutationFn: async (args: { providerId: string; eventName: ProviderActivationEventName }) => {
      try {
        const response = await addProviderActivationEvent(args.providerId, args.eventName);

        return response.data;
      } catch {
        return null;
      }
    },
    onSuccess(_data, variables) {
      queryClient.invalidateQueries(providerQueryKeys.activationEvents(variables.providerId));
    },
  });
};
